module.exports = __webpack_public_path__ + "static/media/calefont41.42680075.png";